import { render } from "./ReposicionRules.vue?vue&type=template&id=5bb27806"
import script from "./ReposicionRules.vue?vue&type=script&lang=js"
export * from "./ReposicionRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__